import {
  getModule,
  Module,
  Mutation,
  Action,
  VuexModule,
} from 'vuex-module-decorators';

import store from '@/stores/timeseries/timeseries-store';
import { LatLng } from 'leaflet';

@Module({
  dynamic: true,
  namespaced: true,
  name: 'TimeseriesModule',
  store,
})
class TimeseriesModule extends VuexModule {
  static _runningId = 0;

  static _generateUniqueId(): string {
    TimeseriesModule._runningId += 1;
    return String(TimeseriesModule._runningId);
  }

  private _coords: Record<string, LatLng | null> = {};
  private _highlightedCoordID = '';

  public get coords(): Record<string, LatLng | null> {
    return this._coords;
  }

  public get activeCoords(): Record<string, LatLng> {
    const activeCoords: Record<string, LatLng> = {};
    Object.entries(this.coords).forEach(([id, coord]) => {
      if (coord !== null) {
        activeCoords[id] = coord;
      }
    });
    return activeCoords;
  }

  public get highlightedCoordID(): string {
    return this._highlightedCoordID;
  }

  @Mutation
  public updateHighlightedCoordID(id: string) {
    this._highlightedCoordID = id;
  }

  @Mutation
  public updateCoords(coords: Record<string, LatLng | null>) {
    this._coords = coords;
  }

  @Action({ commit: 'updateHighlightedCoordID', rawError: true })
  setHighlightedCoordID(id: string) {
    return id;
  }

  @Action({ commit: 'updateCoords', rawError: true })
  addEmptyCoords(): Record<string, LatLng | null> {
    const newCoords = { ...this.coords };
    newCoords[TimeseriesModule._generateUniqueId()] = null;
    return newCoords;
  }

  @Action({ commit: 'updateCoords', rawError: true })
  updateCoordsForID(payload: {
    coords: LatLng;
    id: string;
  }): Record<string, LatLng | null> {
    const { coords, id } = payload;
    const newCoords = { ...this.coords };
    newCoords[id] = coords;
    return newCoords;
  }

  @Action({ commit: 'updateCoords', rawError: true })
  resetCoordsForID(id: string): Record<string, LatLng | null> {
    const newCoords = { ...this.coords };
    newCoords[id] = null;
    return newCoords;
  }

  @Action({ commit: 'updateCoords', rawError: true })
  removeCoordsForID(id: string) {
    const newCoords = { ...this.coords };
    delete newCoords[id];
    return newCoords;
  }

  @Action({ commit: 'updateCoords', rawError: true })
  appendCoords(coords: LatLng): Record<string, LatLng | null> {
    const newCoords = { ...this.coords };
    newCoords[TimeseriesModule._generateUniqueId()] = coords;
    return newCoords;
  }

  @Action({ commit: 'updateCoords', rawError: true })
  resetCoords(): LatLng[] {
    return [];
  }
}

export default getModule(TimeseriesModule);
